import React from "react";
import ReactDOM from "react-dom/client";
import "./services/diagnostics";
import "./config/aws";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// test commit Sat Jun 20 13:46:48 MST 2026
